import React, { useState } from 'react';

import { Label ,Button,Container,Row,Col} from 'reactstrap';
import {  authEndpoints } from '../../utils/Constants';

import AsyncSelect from 'react-select/async';
import useFetchSimple from '../../Services/useFetchSimple';
const Selector = ({ id,style, ...rest }) => {
    return <AsyncSelect id={id} styles={{
        control: provided => ({ ...provided, ...style }),
        // Fixes the overlapping problem of the component
        menu: provided => ({ ...provided, zIndex: 9999 })
    }} {...rest} />
}


const JobLookup = ({ id,onSelect }) => {
    const fetch = useFetchSimple();
    const [selectedOption, setSelectedOption] = useState();
    const handleInputChange = (place, meta) => {
        if (place && meta.action === "input-change") {
            setSelectedOption([place])
        }
    };

    const doAutoComplete = async (input, callback) => {
        const { body } = await fetch(authEndpoints.jobLookup + input);
        const options = body.map(prediction => ({
            value: prediction.id,
            label: 'JB' + prediction.jobReference + '- ' + prediction.status,

        }));
        callback(options);
    };

    const onSelectChange = (c, meta) => {
        if (c && c.value) {
            setSelectedOption(c.value);
        }
    }
    return (<Container>
        <Row>
            <Col style={{ marginTop: '5px' }}>
            <Label>Job Number <b>Search</b>:</Label>
            <Selector
            id={id}
            loadOptions={doAutoComplete}
            onInputChange={handleInputChange}
        onChange={onSelectChange}
        
                options={selectedOption} />
           
            {selectedOption ? <Button onClick={() => onSelect(selectedOption)}>View</Button> : null}
            </Col>
        </Row>
    </Container>);
};

export default JobLookup;


